// extracted by mini-css-extract-plugin
export default {"tag":"cFud3fW1_wk5jVgR_dqU"};